<template>
  <div>
    <ButtonTest />
    <CardTest />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import ButtonTest from "./tests/ButtonTest.vue";
import CardTest from "./tests/CardTest.vue";

export default defineComponent({
  components: { ButtonTest, CardTest },
  name: "UsterInterface",
});
</script>
